/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付エラー
 */
export interface Sgkb575aResAceptError {
    /** 
     * 受付エラー発生システムコード：半角英数混在
     */
    acperrSyscd?: string;
    /** 
     * 受付エラー発生システムコード名称：全角半角混在
     */
    acperrSyscdAname?: string;
    /** 
     * 受付エラーメッセージレベル：半角英数混在
     */
    aceptErrmsg?: string;
    /** 
     * 受付エラーメッセージレベル名称：全角半角混在
     */
    aceptErrmsgAname?: string;
    /** 
     * 受付エラー理由：半角英数混在
     */
    aceptErrrsn?: string;
    /** 
     * 受付エラー理由名称：全角半角混在
     */
    aceptErrrsnAname?: string;
}